import { render, staticRenderFns } from "./UtilWarningAdmin.vue?vue&type=template&id=46642723&scoped=true"
import script from "./UtilWarningAdmin.vue?vue&type=script&lang=js"
export * from "./UtilWarningAdmin.vue?vue&type=script&lang=js"
import style0 from "./UtilWarningAdmin.vue?vue&type=style&index=0&id=46642723&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46642723",
  null
  
)

export default component.exports